import { CashFlow } from '@algoan/dashboard/model';
import { RegularCashFlow } from './timeline-model';

export const getDueDayFromCashFlow = (cashFlow: CashFlow): number | undefined => cashFlow.regularity?.dueDays[0];

export const getDueDayFromRegularCashFlow = (cashFlow: RegularCashFlow): number => cashFlow.regularity.dueDays[0];
